module.exports = __webpack_public_path__ + "media/images/post-office-aa90f18c10ccf58a1f4ee054aa4c3bce.svg";